import type React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Suspense, lazy } from "react";
import TopBar from "./components/TopBar";
import Footer from "./components/Footer";
import LoadingScreen from "./components/LoadingScreen";

// Lazy load pages for better performance
const Landing = lazy(() => import("./pages/Landing"));
const VideosPage = lazy(() => import("./pages/VideosPage"));
const AudiosPage = lazy(() => import("./pages/AudiosPage"));

const App: React.FC = () => {
  return (
    <Router>
      <div className="app-container">
        <TopBar />

        <div className="content-wrapper">
          <Suspense fallback={<LoadingScreen />}>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/videos" element={<VideosPage />} />
              <Route path="/audios" element={<AudiosPage />} />
              {/* Fallback route */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Suspense>
        </div>

        <Footer />
      </div>
    </Router>
  );
};

export default App;
